import React from 'react';

import CommonModal from './common/CommonModal';

export const GuestUserPopup = (props) => {
  return (
    <div>
      <CommonModal
        title="Attention"
        modalSize="xs-size"
        submitTitle="Register"
        cancelTitle="Continue as a Guest"
        footerShow
        {...props}
      >
        <div>
          <p>You are currently logged in as a guest user. Please register yourself to access this page!</p>
        </div>
      </CommonModal>
    </div>
  );
};
